import { useEffect } from 'react';
import { injectIntl } from "react-intl";
import PropTypes from 'prop-types';
import useUserAccount from "../../hooks/useUserAccount";
import { useNavigate, useLocation } from "react-router-dom";

const messages = {
    authError: {
        id: "Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen."
    },
    accountDeleted: {
        id: "Tili suljettu ja tiedot poistettu.",
        defaultMessage: "Tili suljettu ja tiedot poistettu."
    }
}

const LogOut = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userSignOut } = useUserAccount();
    const lng = props.intl.formatMessage;

    /**
     * Logout user and redirect to frontpage
     */
    useEffect(() => {
        const signOut = async (alert) => {
            await userSignOut();
            navigate("/", { state: { alert }, replace: true });
        }
        let alert = "";
        let alertParam = null;
        if (location?.search) {
            const params = new URLSearchParams(location.search);
            alertParam = params.get('alert');
        }
        
        if (alertParam === 'authError') {
            alert = { message: lng(messages.authError), type: 'danger' };
        } else if (alertParam === 'accountDeleted') {
            alert = { message: lng(messages.accountDeleted), type: 'success' };
        } else if (location?.state?.alert) {
            alert = location?.state?.alert;
        }

        // Close and hide chat when user logs out
        if (typeof window.LC_API?.close_chat === 'function' &&
            typeof window.LC_API?.hide_chat_window === 'function') {
            window.LC_API.close_chat();
            window.LC_API.hide_chat_window();
        }

        void signOut(alert);
    }, []);

    return '';
};

LogOut.propTypes = {
    intl: PropTypes.object.isRequired
};

export default injectIntl(LogOut);
